<button class="button-component" :class="computedClasses" :disabled="disabled" :style="computedStyles"><slot></slot></button>